<template lang='pug'>
//- Side-Effect-Chart
div(:class='$style[`cc-side-effect-chart`]')
  div(:class='$style[`cc-side-effect-chart-wrap`]')
    //- nav(v-if='rwdType !== `desktop`' :class='$style[`cc-side-effect-chart-filter-return`]')
    //-   router-link(
    //-     role='button'
    //-     tabindex='0'
    //-     aria-label='返回'
    //-     :to='`/sideeffect/record`'
    //-     :class='$style[`cc-side-effect-chart-filter-return-btn`]')
    //-     IconOpenArrow(:size='20' :color='`#262626`')
    //-     span(:class='$style[`cc-side-effect-userRecordDetail-filter-btn-text`]') 返回

    div.font-bold(:class='$style[`cc-side-effect-chart-banner`]')
      span.no-wrap 趨勢變化(近30天)

    div(v-if='!chartLoaded' :class='$style[`cc-side-effect-chart-container`]')
      div(:class='$style[`cc-side-effect-chart-container-load`]')
        IconLoading(:size='30' :color='`#b1b1b1`')

    div(v-else :class='$style[`cc-side-effect-chart-container`]')
      div(:class='$style[`cc-side-effect-chart-block`]')
        header.font-medium(:class='$style[`cc-side-effect-chart-block-title`]') 紀錄統計
        div(:class='$style[`cc-side-effect-chart-amount`]')
          div(:class='$style[`cc-side-effect-chart-amount-total`]')
            span 總紀錄數
            span.font-bold(:class='$style[`cc-side-effect-chart-amount-number`]') {{ recordAmount.total }}
          div(:class='$style[`cc-side-effect-chart-amount-alertYellow`]')
            span 需留意
            span.font-bold(:class='$style[`cc-side-effect-chart-amount-number`]') {{ recordAmount.yellow }}
          div(:class='$style[`cc-side-effect-chart-amount-alertRed`]')
            span 需緊急就醫
            span.font-bold(:class='$style[`cc-side-effect-chart-amount-number`]') {{ recordAmount.red }}

      //- 日常生活
      div(v-if='chartBasicData' :class='$style[`cc-side-effect-chart-block`]')
        div(v-if='!chartBasicData.labels.length' :class='$style[`cc-side-effect-chart-block-empty`]') 缺少紀錄數據
        header.font-medium(:class='$style[`cc-side-effect-chart-block-title`]') 日常生活
        lineChart(
          :styles='chartStyles'
          :chartOrigin="`se_basic`"
          :chartData="chartBasicData"
          :chartOpt="chartOption1")

      //- 心情影響
      div(v-if='chartGroup1Data' :class='$style[`cc-side-effect-chart-block`]')
        div(v-if='!chartGroup1Data.labels.length' :class='$style[`cc-side-effect-chart-block-empty`]') 缺少紀錄數據
        header.font-medium(:class='$style[`cc-side-effect-chart-block-title`]') 心情影響
        lineChart(
          :styles='chartStyles'
          :chartOrigin="`se_group1`"
          :chartData="chartGroup1Data"
          :chartOpt="chartOption2")

      //- 腸胃道不適
      div(v-if='chartGroup2Data' :class='$style[`cc-side-effect-chart-block`]')
        div(v-if='!chartGroup2Data.labels.length' :class='$style[`cc-side-effect-chart-block-empty`]') 缺少紀錄數據
        header.font-medium(:class='$style[`cc-side-effect-chart-block-title`]') 腸胃道症狀
        lineChart(
          :styles='chartStyles'
          :chartOrigin="`se_group2`"
          :chartData="chartGroup2Data"
          :chartOpt="chartOption2")

      //- 外部生理不適
      div(v-if='chartGroup3Data' :class='$style[`cc-side-effect-chart-block`]')
        div(v-if='!chartGroup3Data.labels.length' :class='$style[`cc-side-effect-chart-block-empty`]') 缺少紀錄數據
        header.font-medium(:class='$style[`cc-side-effect-chart-block-title`]') 外部生理
        lineChart(
          :styles='chartStyles'
          :chartOrigin="`se_group3`"
          :chartData="chartGroup3Data"
          :chartOpt="chartOption2")

      



</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import LineChart from '../charts/LineChart';
import IconLoading from '../../icon/Loading';
// import IconOpenArrow from '../../icon/OpenArrow';

import {
  putLoadSideEffectCharts,
  putLoadSideEffectAmount,
} from '../../../js/restapi';

export default {
  components: {
    LineChart,
    IconLoading,
    // IconOpenArrow,
  },

  created() {
    this.axiosLoadRecordCharts();
  },

  data() {
    return {
      recordAmount: {},
      // sideEffectList: [
      //   '體重(Kg)', '體溫(攝氏)', '生活品質', '疼痛指數', '心情狀態', '食慾減少', '胃部不適', '腹瀉程度', '便秘程度', '噁心嘔吐', '咳嗽程度', '喘氣程度', '感覺疲憊', '憂鬱程度', '失眠程度', '化療引起手麻腳麻',
      // ],
      chartLoaded: false,
      chartCount: 0,
      chartSearchDays: 30,
      colorTheme: {
        basic: ['#F2AB39', '#bc5f6a', '#7bc5ae'],
        group: ['#F2AB39', '#bc5f6a', '#7bc5ae', '#3d82ab'],
      },
      chartBasicData: {
        labels: [],
        datasets: [],
      },
      chartGroup1Data: {
        labels: [],
        datasets: [],
      },
      chartGroup2Data: {
        labels: [],
        datasets: [],
      },
      chartGroup3Data: {
        labels: [],
        datasets: [],
      },

      chartOption1: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        plugins: {
          legend: {
            labels: {
              font: {
                size: 14
              }
            }
          },
          title: true
        },
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [{
            ticks: {
              display: true
            },
            stacked: false,
          }]
        },
      },

      chartOption2: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        plugins: {
          legend: {
            labels: {
              font: {
                size: 14
              }
            }
          },
          title: true
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            ticks: {
              callback: function(value, index, ticks) {
                let showLabel;
                switch (value) {
                  case 4:
                    showLabel = "嚴重"
                    break;
                  case 3:
                    showLabel = "中等"
                    break;
                  case 2:
                    showLabel = "輕微"
                    break;
                  case 1:
                    showLabel = "沒有"
                    break;
                  default:
                    break;
                }
                return showLabel;
              },
              display: true
            },
            stacked: false,
          }]
        },
      },
    }
  },

  methods: {
    axiosLoadRecordCharts() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const CONFIG = {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      };

      axios.all([
        putLoadSideEffectCharts('', {
          auth_id: this.loginDjangoId,
          days: this.chartSearchDays,
          effect: 'se_basic',
        }, CONFIG),
        putLoadSideEffectCharts('', {
          auth_id: this.loginDjangoId,
          days: this.chartSearchDays,
          effect: 'se_group1',
        }, CONFIG),
        putLoadSideEffectCharts('', {
          auth_id: this.loginDjangoId,
          days: this.chartSearchDays,
          effect: 'se_group2',
        }, CONFIG),
        putLoadSideEffectCharts('', {
          auth_id: this.loginDjangoId,
          days: this.chartSearchDays,
          effect: 'se_group3',
        }, CONFIG),
        putLoadSideEffectAmount('', {
          auth_id: this.loginDjangoId,
        }, CONFIG),
      ])
      .then(axios.spread((basic, group1, group2, group3, amount) => {
        this.chartCount = basic.data.chart['date'].length;
        this.chartBasicData.labels = basic.data.chart['date'];
        this.chartGroup1Data.labels = group1.data.chart['date'];
        this.chartGroup2Data.labels = group2.data.chart['date'];
        this.chartGroup3Data.labels = group3.data.chart['date'];
        this.recordAmount = amount.data;

        basic.data.chart['labels'].map((x, i) => {
          this.chartBasicData.datasets.push({
            label: x.label,
            data: x.data,
            backgroundColor: this.colorTheme.basic[i],
            borderColor: this.colorTheme.basic[i],
            // pointBorderColor: this.groupBasicColor[],
            borderWidth: 1,
            fill: false,
            lineTension: 0.4,
          });
        });

        group1.data.chart['labels'].map((x, i) => {
          this.chartGroup1Data.datasets.push({
            label: x.label,
            data: x.data,
            backgroundColor: this.colorTheme.group[i],
            borderColor: this.colorTheme.group[i],
            // pointBorderColor: this.groupBasicColor[],
            borderWidth: 1,
            fill: false,
            lineTension: 0.4,
          });
        });

        group2.data.chart['labels'].map((x, i) => {
          this.chartGroup2Data.datasets.push({
            label: x.label,
            data: x.data,
            backgroundColor: this.colorTheme.group[i],
            borderColor: this.colorTheme.group[i],
            // pointBorderColor: this.groupBasicColor[],
            borderWidth: 1,
            fill: false,
            lineTension: 0.4,
          });
        });

        group3.data.chart['labels'].map((x, i) => {
          this.chartGroup3Data.datasets.push({
            label: x.label,
            data: x.data,
            backgroundColor: this.colorTheme.group[i],
            borderColor: this.colorTheme.group[i],
            // pointBorderColor: this.groupBasicColor[],
            borderWidth: 1,
            fill: false,
            lineTension: 0.4,
          });
        });

        this.chartLoaded = true;
      }))
      .catch((error) => {
        console.log('外部', error);
      })
    },
  },

  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      rwdType: 'global/exportRwdType',
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      authJwtToken: 'user/exportUserJwtToken',
    }),

    chartStyles() {
      return {
        width: '100%',
        height: '240px',
        position: 'relative'
      }
    },
  }
};

</script>
<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectCharts.scss';
</style>
